export default __webpack_public_path__ + "static/voice_call-74659df735e085097e2abdd28bfcd7a1.png";